<template>
    <div class="page-wrapper" ref="book">
        <div class="movie-box page-fixed book-top-wrapper">
            <!-- 搜索框 -->
            <div class="movie-wrapper header">
                <router-link :to="'/bookSearch'" class="movie-wrapper acea-row row-middle page-background-color-white s-content">
                    <span class="iconfont icon-xiazai5 page-margin-right2"></span>搜索书名或作者
                </router-link>
            </div>

            <!-- 导航 -->
            <ul class="movie-horizontal-scroll-bar page-background-color-white padding20 book-nav-wrapper" ref="bookNavBar">
                <li class="page-margin-right2" :class="{checkli: currentCheck == ind}" v-for="(item, ind) in navList" :ref="'bookNav'+ind" :key="ind" @click="changeCurrentli(item.id, ind)">{{item.title}}</li>
            </ul>
        </div>
        <!-- list -->
        <div class="movie-box data-wrapper">
            <GoodList :boxStyle="boxStyle" :bottomBoxStyle="bottomBoxStyle" :goodList="currentList" :isSort="false" :isShowSale="false" :isShowShopCart="false" :isPrice="false" :isAuthor="true"></GoodList>
            <div class="movie-box">
                <Loading :loaded="loaded" :loading="loading"></Loading>
            </div>
        </div>
    </div>
</template>

<script>
import GoodList from "@components/GoodList";
import { debounceFn } from "@utils/movie.js";
import Loading from "@components/Loading";
export default {
    name: "BookType",
    components: {
        GoodList,
        Loading
    },
    data: function () {
        return {
            boxStyle: {
                "box-shadow": "0 0 0 0",
                "width": "46%",
                "height": "4rem",
                "border-radius": "0.2rem",
                "margin-left": "0.26rem"
            },
            bottomBoxStyle: {
                "padding-bottom":"0"
            },
            currentCheck: this.$route.params.id || null,
            currentList: [],
            loaded: false,
            loading: false,
            page: 1,
            limit: 5,
            domScroll: null,
            navList: [
                {
                    title: "世界政治",
                    id: 0,
                    dataList: [
                    {
                        id: 111,
                        image: "http://img3m2.ddimg.cn/0/27/28473192-1_l_6.jpg",
                        store_name: "1你当像鸟飞往你的山",
                        price: "110.0"
                    }, {
                        id: 112,
                        image: "http://img3m6.ddimg.cn/63/10/29207736-1_l_27.jpg",
                        store_name: "1山海经（全译彩绘图说典藏版）附赠西洋古董《谟区查抄本彩绘山海经图》",
                        price: "120.0"
                    }, {
                        id: 113,
                        image: "http://img3m2.ddimg.cn/14/2/28509242-1_l_11.jpg",
                        store_name: "1古代人的日常生活",
                        price: "130.0"
                    }, {
                        id: 114,
                        image: "http://img3m6.ddimg.cn/27/14/28530936-1_l_46.jpg",
                        store_name: "1地图上的全景世界史",
                        price: "210.0"
                    }, {
                        id: 115,
                        image: "http://img3m8.ddimg.cn/97/30/28991158-1_l_15.jpg",
                        store_name: "1国际安徒生奖曹文轩拼音精选集（共八册，含小河弯弯，红葫芦，愤怒的哇哇，月光下的秘密，哑牛，狂奔的鸭群，八哥，有个丫头叫草环）",
                        price: "50.0"
                    }, {
                        id: 116,
                        image: "http://img3m5.ddimg.cn/58/2/29151895-1_l_5.jpg",
                        store_name: "1九神鹿绘本馆——广陵散",
                        price: "30.0"
                    }, {
                        id: 111,
                        image: "http://img3m2.ddimg.cn/0/27/28473192-1_l_6.jpg",
                        store_name: "1你当像鸟飞往你的山",
                        price: "110.0"
                    }, {
                        id: 112,
                        image: "http://img3m6.ddimg.cn/63/10/29207736-1_l_27.jpg",
                        store_name: "1山海经（全译彩绘图说典藏版）附赠西洋古董《谟区查抄本彩绘山海经图》",
                        price: "120.0"
                    }, {
                        id: 113,
                        image: "http://img3m2.ddimg.cn/14/2/28509242-1_l_11.jpg",
                        store_name: "1古代人的日常生活",
                        price: "130.0"
                    }, {
                        id: 114,
                        image: "http://img3m6.ddimg.cn/27/14/28530936-1_l_46.jpg",
                        store_name: "1地图上的全景世界史",
                        price: "210.0"
                    }, {
                        id: 115,
                        image: "http://img3m8.ddimg.cn/97/30/28991158-1_l_15.jpg",
                        store_name: "1国际安徒生奖曹文轩拼音精选集（共八册，含小河弯弯，红葫芦，愤怒的哇哇，月光下的秘密，哑牛，狂奔的鸭群，八哥，有个丫头叫草环）",
                        price: "50.0"
                    }, {
                        id: 116,
                        image: "http://img3m5.ddimg.cn/58/2/29151895-1_l_5.jpg",
                        store_name: "1九神鹿绘本馆——广陵散",
                        price: "30.0"
                    }
                ]
                }, {
                    title: "中国共产党",
                    id: 1,
                    dataList: [
                    {
                        id: 111,
                        image: "http://img3m5.ddimg.cn/31/23/25308985-1_l_20.jpg",
                        store_name: "2你当像鸟飞往你的山",
                        price: "110.0"
                    }, {
                        id: 112,
                        image: "http://img3m0.ddimg.cn/14/20/29225210-1_l_11.jpg",
                        store_name: "2山海经",
                        price: "120.0"
                    }, {
                        id: 113,
                        image: "http://img3m6.ddimg.cn/25/3/1901072176-1_l_2.jpg",
                        store_name: "2古代人的日常生活",
                        price: "130.0"
                    }, {
                        id: 114,
                        image: "http://img3m6.ddimg.cn/27/14/28530936-1_l_46.jpg",
                        store_name: "2地图上的全景世界史",
                        price: "210.0"
                    }, {
                        id: 115,
                        image: "http://img3m8.ddimg.cn/97/30/28991158-1_l_15.jpg",
                        store_name: "2国际安徒生奖曹文轩拼音精选集（共八册，含小河弯弯，红葫芦，愤怒的哇哇，月光下的秘密，哑牛，狂奔的鸭群，八哥，有个丫头叫草环）",
                        price: "50.0"
                    }, {
                        id: 116,
                        image: "http://img3m5.ddimg.cn/58/2/29151895-1_l_5.jpg",
                        store_name: "2九神鹿绘本馆——广陵散",
                        price: "30.0"
                    }
                ]
                }, {
                    title: "党政读物",
                    id: 2,
                    dataList: [
                    {
                        id: 111,
                        image: "http://img3m4.ddimg.cn/47/7/29215244-1_l_24.jpg",
                        store_name: "3你当像鸟飞往你的山",
                        price: "110.0"
                    }, {
                        id: 112,
                        image: "http://img3m5.ddimg.cn/85/28/29114995-1_l_8.jpg",
                        store_name: "3山海经（全译彩绘图说典藏版）附赠西洋古董《谟区查抄本彩绘山海经图》",
                        price: "120.0"
                    }, {
                        id: 113,
                        image: "http://img3m2.ddimg.cn/14/2/28509242-1_l_11.jpg",
                        store_name: "3古代人的日常生活",
                        price: "130.0"
                    }, {
                        id: 114,
                        image: "http://img3m6.ddimg.cn/27/14/28530936-1_l_46.jpg",
                        store_name: "3地图上的全景世界史",
                        price: "210.0"
                    }, {
                        id: 115,
                        image: "http://img3m8.ddimg.cn/97/30/28991158-1_l_15.jpg",
                        store_name: "3国际安徒生奖曹文轩拼音精选集（共八册，含小河弯弯，红葫芦，愤怒的哇哇，月光下的秘密，哑牛，狂奔的鸭群，八哥，有个丫头叫草环）",
                        price: "50.0"
                    }, {
                        id: 116,
                        image: "http://img3m5.ddimg.cn/58/2/29151895-1_l_5.jpg",
                        store_name: "3九神鹿绘本馆——广陵散",
                        price: "30.0"
                    }
                ]
                }, {
                    title: "各国共产党",
                    id: 3,
                    dataList: [
                    {
                        id: 111,
                        image: "http://img3m5.ddimg.cn/30/35/29158995-1_l_29.jpg",
                        store_name: "4你当像鸟飞往你的山",
                        price: "110.0"
                    }, {
                        id: 112,
                        image: "http://img3m3.ddimg.cn/20/12/29166113-1_l_23.jpg",
                        store_name: "4山海经（全译彩绘图说典藏版）附赠西洋古董《谟区查抄本彩绘山海经图》",
                        price: "120.0"
                    }, {
                        id: 113,
                        image: "http://img3m2.ddimg.cn/14/2/28509242-1_l_11.jpg",
                        store_name: "4古代人的日常生活",
                        price: "130.0"
                    }, {
                        id: 114,
                        image: "http://img3m6.ddimg.cn/27/14/28530936-1_l_46.jpg",
                        store_name: "4地图上的全景世界史",
                        price: "210.0"
                    }, {
                        id: 115,
                        image: "http://img3m8.ddimg.cn/97/30/28991158-1_l_15.jpg",
                        store_name: "4国际安徒生奖曹文轩拼音精选集（共八册，含小河弯弯，红葫芦，愤怒的哇哇，月光下的秘密，哑牛，狂奔的鸭群，八哥，有个丫头叫草环）",
                        price: "50.0"
                    }, {
                        id: 116,
                        image: "http://img3m5.ddimg.cn/58/2/29151895-1_l_5.jpg",
                        store_name: "4九神鹿绘本馆——广陵散",
                        price: "30.0"
                    }
                ]
                }, {
                    title: "各国政治",
                    id: 4,
                    dataList: [
                    {
                        id: 111,
                        image: "http://img3m9.ddimg.cn/88/27/26487439-1_l_24.jpg",
                        store_name: "5你当像鸟飞往你的山",
                        price: "110.0"
                    }, {
                        id: 112,
                        image: "http://img3m9.ddimg.cn/26/25/29157209-1_l_15.jpg",
                        store_name: "猫咪好大冒险",
                        price: "120.0"
                    }, {
                        id: 113,
                        image: "http://img3m2.ddimg.cn/14/2/28509242-1_l_11.jpg",
                        store_name: "5古代人的日常生活",
                        price: "130.0"
                    }, {
                        id: 114,
                        image: "http://img3m6.ddimg.cn/27/14/28530936-1_l_46.jpg",
                        store_name: "5地图上的全景世界史",
                        price: "210.0"
                    }, {
                        id: 115,
                        image: "http://img3m8.ddimg.cn/97/30/28991158-1_l_15.jpg",
                        store_name: "5国际安徒生奖曹文轩拼音精选集（共八册，含小河弯弯，红葫芦，愤怒的哇哇，月光下的秘密，哑牛，狂奔的鸭群，八哥，有个丫头叫草环）",
                        price: "50.0"
                    }, {
                        id: 116,
                        image: "http://img3m5.ddimg.cn/58/2/29151895-1_l_5.jpg",
                        store_name: "5九神鹿绘本馆——广陵散",
                        price: "30.0"
                    }
                ]
                }
            ]
        }
    },
    mounted: function () {
        this.getData();
        
        //获取dom
        this.domScroll = this.$refs.book;
        const bookDom = this.$refs.book;
        bookDom.addEventListener("scroll", debounceFn(this.onScroll, 50), false);
    },
    deactivated: function () {
        this.domScroll.removeEventListener("scroll", this.onScroll);
    },
    methods: {
        onScroll: function (e) {
            //console.log(e.target.scrollTop, "=top", e.target.scrollHeight,"=scrollHeight", this.domScroll.clientHeight,"clientHeight");
            const distance = Math.ceil((e.target.scrollTop / (e.target.scrollHeight-this.domScroll.clientHeight))*100);
            console.log( distance + '%', "占比");
            if ( distance > 80) {
                this.getBookList(2);
            }
        },
        getData: function () {
            //请求导航nav数据


            if (!this.currentCheck) {
                this.currentCheck = this.navList[0].id;//没有带参数过来 默认选择nav数据第一个
            }
            //传参数 请求数据赋值
            this.getBookList(1);

        },
        getBookList: async function (n) {
            //模拟数据
            if (n == 1) {
                this.loading = true;
                this.navList.forEach((item)=> {
                    if (this.currentCheck == item.id) {
                        this.currentList =item.dataList;
                        this.loading = false;
                        this.page++;
                    }
                });
            }

            // if (this.loaded || this.loading) return;
            // const { limit, page, currentCheck } = this;
            // this.loading = true;
            // await gfn({limit, page, id: currentCheck }).then((res)=>{
            //     if (res.data.length > 0) {
            //         this.currentList = this.currentList.concat(res.data);
            //         this.page++;
            //     }
            //     this.loading = false;
            //     this.loaded = res.data.length < this.limit;
            // }).catch((err)=>{
            //     console.log(err);
            //     this.loading = false;
            // });

            //模拟
            if (n == 2 && !this.loaded) {
                console.log(this.page,"page");
                if (this.page < 8) {
                     this.loading = true;
                    await setTimeout(()=>{
                        const arr = Array.from({length: 10}, ()=>{
                        return {
                            id: 111,
                            image: "http://img3m2.ddimg.cn/0/27/28473192-1_l_6.jpg",
                            store_name: "you you 嘿"+ this.page + "我是新加的",
                            price: "随便买✿"
                        }
                        });
                        this.currentList = this.currentList.concat(arr);
                        this.page++;
                        this.loading = false;
                    }, 200);
                } else {
                    this.$dialog.error("已加载完毕！！目前在第"+(this.page-1)+"页");
                    this.loaded = true;
                }
            }


        },
        changeCurrentli: function (id, ind) {  //点击切换导航
            if (this.currentCheck === id) return;
            this.currentCheck = id;

            //导航条移动到中间
            const bnb = this.$refs.bookNavBar;
            const bn =  this.$refs[`bookNav${ind}`][0];
            const center = bn.offsetLeft - (bnb.clientWidth/2) + (bn.offsetWidth/2);
            this.$refs.bookNavBar.scrollTo(center, 0);
            

            this.page = 1;
            this.currentList = [];
            this.loading = false;
            this.loaded = false;
            this.getBookList(1);
            this.domScroll.scrollTo(0, 0);
        }
    }
}
</script>

<style scoped>
.header {
    height: 1.1rem;
    padding: .2rem;
}
.s-content {
    height: 100%;
    border-radius: .5rem;
}
.book-nav-wrapper {
    height: 1rem;
}
.book-nav-wrapper li {
    display: inline-block;
    height: 100%;
    box-sizing: border-box;
    padding: 0 .2rem;
    line-height: .6rem;
}
.checkli {
    background: #ff3c2b;
    color: #fff;
    border-radius: .2rem;
}
.data-wrapper {
    padding-bottom: .3rem;
    margin-top: 2.1rem;
}
.book-top-wrapper {
    top: 0;
    left: 0;
    z-index: 100;
    background: rgb(245, 245, 245);
}
</style>